import demoPostSrc9 from '@/assets/images/demo/demo-post-9.jpg'
import demoPostSrc10 from '@/assets/images/demo/demo-post-10.jpg'
import demoPostSrc11 from '@/assets/images/demo/demo-post-11.png'
import demoPostSrc12 from '@/assets/images/demo/demo-post-12.png'
import demoPostSrc13 from '@/assets/images/demo/demo-post-13.png'
import demoPostSrc14 from '@/assets/images/demo/demo-post-14.png'
import demoPostSrc15 from '@/assets/images/demo/demo-post-15.png'
import demoPostSrc16 from '@/assets/images/demo/demo-post-16.png'
import demoPostSrc17 from '@/assets/images/demo/demo-post-17.png'
import demoPostSrc18 from '@/assets/images/demo/demo-post-18.png'
import {
  makeKolInfo1,
  makeKolInfo2,
  makeKolInfo3,
  makeKolInfo4,
  makeKolInfo5,
} from '@/constants/mock-data/kol-info'
import {
  makePostContent1,
  makePostContent2,
  makePostContent3,
  makePostContent4,
  makePostContent5,
  makePostContent6,
} from '@/constants/mock-data/post'
import { SupportedLanguages } from '@/i18n/config'
import {
  InsightReportCommentAnalysisResponse,
  InsightReportCommentsResponse,
  InsightReportCustomPostTypesResponse,
  InsightReportInfinitePostsResponse,
  InsightReportKolAnalysisResponse,
  InsightReportKolPerformanceResponse,
  InsightReportKolsResponse,
  InsightReportListResponse,
  InsightReportOverviewResponse,
  KolRankingKey,
  KolRankingKol,
  kolRankingSchema,
  OverviewKol,
  PostRankingPost,
} from '@/types/schema/api/insight-report'
import { KolSchemaModel } from '@/types/schema/kol-schema'

const DEMO_REPORT_ID = 'demo'

const mapDemoInsightMockKol = (kol: KolSchemaModel): OverviewKol => {
  return {
    id: 56789,
    uuid: kol.id,
    name: kol.name,
    is_verified: kol.verified,
    is_radar_star: kol.isRadarStar,
    total_follower_count: kol.follower,
    platforms: [],
  }
}

const makeDemoInsightReportPerformanceResponse =
  (): InsightReportKolPerformanceResponse => {
    return {
      data: {
        post_count: 10,
        like_count: 1254,
        comment_count: 38,
        share_count: 11,
        engagement_count: 1303,
        engagement_rate: 0.003607959107950801,
        view_count: 660,
        view_rate: 0.003773326015367728,
        reach_count: 36,
        reach_rate: 0.0002414972831555645,
        click_count: 4,
        click_rate: 0.00002683303146172939,
      },
    }
  }

const makeDemoInsightReportKols = (
  locale?: SupportedLanguages,
): [OverviewKol, OverviewKol, OverviewKol, OverviewKol, OverviewKol] => {
  return [
    {
      ...mapDemoInsightMockKol(makeKolInfo1(locale)),
      id: 35526,
      total_follower_count: 869241,
      platforms: [
        {
          platform: 'facebook',
          follower_count: 782702,
        },
        {
          platform: 'instagram',
          follower_count: 83939,
        },
        {
          platform: 'youtube',
          follower_count: 2600,
        },
      ],
    },
    {
      ...mapDemoInsightMockKol(makeKolInfo2(locale)),
      id: 35525,
      total_follower_count: 3053,
      platforms: [
        {
          platform: 'instagram',
          follower_count: 3053,
        },
      ],
    },
    {
      ...mapDemoInsightMockKol(makeKolInfo3(locale)),
      id: 35523,
      total_follower_count: 47400,
      platforms: [
        {
          platform: 'youtube',
          follower_count: 47400,
        },
      ],
    },
    {
      ...mapDemoInsightMockKol(makeKolInfo4(locale)),
      id: 35524,
      total_follower_count: 68960,
      platforms: [
        {
          platform: 'facebook',
          follower_count: 62078,
        },
        {
          platform: 'instagram',
          follower_count: 6882,
        },
      ],
    },
    {
      ...mapDemoInsightMockKol(makeKolInfo5(locale)),
      id: 35522,
      total_follower_count: 30585,
      platforms: [
        {
          platform: 'facebook',
          follower_count: 9860,
        },
        {
          platform: 'instagram',
          follower_count: 20725,
        },
      ],
    },
  ]
}

const getOverviewAiSummary = (locale?: SupportedLanguages): string[] => {
  switch (locale) {
    case SupportedLanguages.ja:
      return [
        `データによると、デザート系インフルエンサーの中で最も優れた成果を出したのは Foodieeee Food で、いいね数とコメント数が他を大きく上回っており、視聴者の高い反応が見受けられます。グルメ探検家 はシェア数と投稿数が安定しており、影響力の持続性が見られました。\n
        しかし、全体的な成果はさらに改善の余地があります。インタラクション率（0.36％）とリーチ率（0.036％）は低く、参加率が課題です。抽選企画や投票など、参加型コンテンツを増やすことで改善が期待できます。\n
        リンクのクリック率は取得できませんでしたが、より目立つように工夫し、行動喚起を促すべきです。視聴率の低さに対しては、掲載時間やプラットフォームの調整が効果的かもしれません。今後はインタラクションと視聴者参加の強化が重要となります。`,
      ]
    case SupportedLanguages.zhTW:
      return [
        `根據報告數據顯示，甜點類別的網紅合作中，表現最優異的是「Foodieeee Food」，在按讚數和留言數上均居於領先地位，顯示出其內容吸引了較高的觀眾互動。而「美食探險家」則在分享數及合作數量上相對較佳，顯示出其穩定的影響力。\n
        然而，整體效益尚可進一步提升。互動率僅為 0.36% 和觸及率 0.036% 表示觀眾的參與度不高，這可能與內容形式及行銷策略有關。可考慮增加互動性強的內容種類，例如舉辦抽獎或觀眾投票，加強與受眾的連結。\n
        另外，儘管連結點擊率無法提供數據，但應優化連結的展示方式，確保觀眾能更容易地參與行動。針對較低的觀看率，或可考慮調整合作時間或合作平臺以提升曝光率。總體來說，提高互動性及受眾參與將是未來合作的優化方向。`,
      ]
    default:
      return [
        `Although link click-through data is unavailable, enhancing link visibility is recommended to encourage actions. To address the low view rate, try adjusting the campaign timing or platforms. Increasing interactivity and engagement will be key to optimizing future collaborations.\n
        However, overall performance can be improved. The interaction rate (0.36%) and reach rate (0.036%) indicate low engagement. Consider adding more interactive content such as giveaways or polls to boost audience involvement.\n
        Based on the data, Foodieeee Food stood out with the highest number of likes and comments among dessert-focused influencers, indicating strong audience engagement. Gourmet Explorer performed well in terms of shares and post count, suggesting steady influence.`,
      ]
  }
}

const getInsightReportName = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.ja:
      return 'デモ用'
    case SupportedLanguages.zhTW:
      return 'Demo 用'
    default:
      return 'Demo Purpose'
  }
}

const getInsightReportKeywords = (locale?: SupportedLanguages): string[] => {
  switch (locale) {
    case SupportedLanguages.ja:
      return ['デザート']
    case SupportedLanguages.zhTW:
      return ['甜點']
    default:
      return ['dessert']
  }
}

const makeDemoInsightReportOverviewResponse = (
  locale?: SupportedLanguages,
): InsightReportOverviewResponse => {
  const kols = makeDemoInsightReportKols(locale)

  return {
    data: {
      id: DEMO_REPORT_ID as unknown as number,
      name: getInsightReportName(locale),
      budget: 40000,
      start_at: '2025-02-28T16:00:00Z',
      end_at: '2025-03-31T15:59:59.999Z',
      updated_at: '2025-04-23T11:30:23.326Z',
      snapshot_at: '2025-04-23T11:30:23.333Z',
      keywords: getInsightReportKeywords(locale),
      total_engagement_count: 1303,
      total_reach_count: 36,
      cpe: 30.69838833461243,
      cpv: 60.60606060606061,
      cpev: 20.376974019358126,
      womm: 15939.055710148812,
      last_crawler_status: 'succeeded',
      kols,
      posts: [
        {
          id: 27964,
          platform: 'facebook',
          is_custom_platform: false,
          post_type: 'post',
          is_custom_post_type: false,
          kol_uuid: kols[4].uuid,
          published_at: '2025-03-12T16:03:03Z',
          like_count: 11,
          comment_count: 0,
          share_count: 0,
          engagement_count: 11,
          view_count: 3,
          positive_comment_count: 0,
          negative_comment_count: 0,
        },
        {
          id: 27965,
          platform: 'facebook',
          is_custom_platform: false,
          post_type: 'post',
          is_custom_post_type: false,
          kol_uuid: kols[3].uuid,
          published_at: '2025-03-06T06:39:02Z',
          like_count: 54,
          comment_count: 0,
          share_count: 1,
          engagement_count: 55,
          reach_count: 3,
          click_count: 1,
          positive_comment_count: 0,
          negative_comment_count: 0,
        },
        {
          id: 27966,
          platform: 'facebook',
          is_custom_platform: false,
          post_type: 'post',
          is_custom_post_type: false,
          kol_uuid: kols[3].uuid,
          published_at: '2025-03-31T14:20:02Z',
          like_count: 161,
          comment_count: 3,
          share_count: 8,
          engagement_count: 172,
          positive_comment_count: 0,
          negative_comment_count: 0,
        },
        {
          id: 27967,
          platform: 'instagram',
          is_custom_platform: false,
          post_type: 'post',
          is_custom_post_type: false,
          kol_uuid: kols[1].uuid,
          published_at: '2025-03-25T09:59:40Z',
          like_count: 0,
          comment_count: 2,
          engagement_count: 2,
          view_count: 30,
          reach_count: 3,
          click_count: 1,
          positive_comment_count: 0,
          negative_comment_count: 0,
        },
        {
          id: 27968,
          platform: 'youtube',
          is_custom_platform: false,
          post_type: 'shorts',
          is_custom_post_type: false,
          kol_uuid: kols[2].uuid,
          published_at: '2025-03-14T05:18:11Z',
          like_count: 6,
          comment_count: 0,
          share_count: 0,
          engagement_count: 6,
          view_count: 445,
          positive_comment_count: 0,
          negative_comment_count: 0,
        },
        {
          id: 27969,
          platform: 'facebook',
          is_custom_platform: false,
          post_type: 'post',
          is_custom_post_type: false,
          kol_uuid: kols[3].uuid,
          published_at: '2025-03-30T07:29:41Z',
          like_count: 149,
          comment_count: 0,
          share_count: 0,
          engagement_count: 149,
          positive_comment_count: 0,
          negative_comment_count: 0,
        },
        {
          id: 27970,
          platform: 'instagram',
          is_custom_platform: false,
          post_type: 'post',
          is_custom_post_type: false,
          kol_uuid: kols[0].uuid,
          published_at: '2025-03-03T07:57:25Z',
          like_count: 586,
          comment_count: 13,
          share_count: 2,
          engagement_count: 601,
          view_count: 100,
          reach_count: 30,
          click_count: 2,
          positive_comment_count: 0,
          negative_comment_count: 0,
        },
        {
          id: 27971,
          platform: 'instagram',
          is_custom_platform: false,
          post_type: 'post',
          is_custom_post_type: false,
          kol_uuid: kols[3].uuid,
          published_at: '2025-03-06T06:39:08Z',
          like_count: 20,
          comment_count: 0,
          engagement_count: 20,
          view_count: 40,
          positive_comment_count: 0,
          negative_comment_count: 0,
        },
        {
          id: 27972,
          platform: 'instagram',
          is_custom_platform: false,
          post_type: 'post',
          is_custom_post_type: false,
          kol_uuid: kols[1].uuid,
          published_at: '2025-03-09T14:49:20Z',
          like_count: 0,
          comment_count: 12,
          engagement_count: 12,
          view_count: 2,
          positive_comment_count: 0,
          negative_comment_count: 0,
        },
        {
          id: 27973,
          platform: 'instagram',
          is_custom_platform: false,
          post_type: 'post',
          is_custom_post_type: false,
          kol_uuid: kols[4].uuid,
          published_at: '2025-03-12T16:02:58Z',
          like_count: 267,
          comment_count: 8,
          engagement_count: 275,
          view_count: 40,
          positive_comment_count: 0,
          negative_comment_count: 0,
        },
      ],
      owner: {
        id: 41969,
        name: 'Joy',
      },
      ai: {
        quota: 2,
        summaries: getOverviewAiSummary(locale),
      },
    },
  }
}

const makeDemoInsightReportCustomPostTypesResponse =
  (): InsightReportCustomPostTypesResponse => {
    return {
      data: [
        {
          platform: 'facebook',
          is_custom_platform: false,
          post_type: 'post',
          is_custom_post_type: false,
        },
        {
          platform: 'instagram',
          is_custom_platform: false,
          post_type: 'post',
          is_custom_post_type: false,
        },
        {
          platform: 'youtube',
          is_custom_platform: false,
          post_type: 'shorts',
          is_custom_post_type: false,
        },
      ],
    }
  }

const getKolAnalysisAiSummary = (locale: SupportedLanguages): string => {
  const kol = makeKolInfo3(locale)

  switch (locale) {
    case SupportedLanguages.zhTW:
      return `${kol.name}的互動率最高，達 1.33%，反映內容對特定受眾的吸引力。低互動率的 KOL 應重新評估其內容策略，增強與粉絲的互動，提升內容的相關性。`
    case SupportedLanguages.ja:
      return `${kol.name}はエンゲージメント率1.33％と最も高く、特定の視聴者への強い魅力を示しています。低いエンゲージメントのインフルエンサーは、コンテンツ戦略の見直しが必要です。`
    default:
      return `${kol.name} had the highest engagement rate at 1.33%, showing strong appeal to a targeted audience. Influencers with lower engagement should reassess their content strategy to improve relevance and interaction.`
  }
}

const getKolAnalysisKolRanking = (
  locale: SupportedLanguages,
  isPercentageValue: boolean,
): KolRankingKol[] => {
  const kols = makeDemoInsightReportKols(locale)
  const values = isPercentageValue
    ? [
        0.013268998793727383, 0.007159961400540869, 0.003930560104814936,
        0.002906131938390003,
      ]
    : [0, 586, 20, 267]
  return values.map((value, index) => ({
    ...kols[index],
    value,
  }))
}

const getKolAnalysisPostsRanking = (
  locale: SupportedLanguages,
  isPercentageValue: boolean,
  customValues?: Pick<
    PostRankingPost,
    'value' | 'thumbnail_url' | 'author' | 'content'
  >[],
): PostRankingPost[] => {
  const postContent1 = makePostContent1(locale)
  const postContent2 = makePostContent2(locale)
  const postContent3 = makePostContent3(locale)
  const postContent4 = makePostContent4(locale)
  const postContent5 = makePostContent5(locale)

  const kols = makeDemoInsightReportKols(locale)

  const values = isPercentageValue
    ? [
        0.013268998793727383, 0.007159961400540869, 0.003930560104814936,
        0.002906131938390003, 0.0006550933508024893,
      ]
    : [601, 275, 20, 12, 2]

  return [
    {
      content: postContent1,
      thumbnail_url: demoPostSrc11,
      author: {
        uuid: kols[0].uuid,
        name: kols[0].name,
        is_verified: false,
        is_radar_star: false,
      },
      value: values[0],
      platform: 'instagram',
      is_custom_platform: false,
      origin_url: '',
      source_post_id: '',
      platform_user_id: '',
      ...(customValues?.[0] ?? {}),
    },
    {
      content: postContent2,
      thumbnail_url: demoPostSrc12,
      author: {
        uuid: kols[1].uuid,
        name: kols[1].name,
        is_verified: false,
        is_radar_star: false,
      },
      value: values[1],
      platform: 'instagram',
      is_custom_platform: false,
      origin_url: '',
      source_post_id: '',
      platform_user_id: '',
      ...(customValues?.[1] ?? {}),
    },
    {
      content: postContent3,
      thumbnail_url: demoPostSrc13,
      author: {
        uuid: kols[2].uuid,
        name: kols[2].name,
        is_verified: false,
        is_radar_star: false,
      },
      value: values[2],
      platform: 'instagram',
      is_custom_platform: false,
      origin_url: '',
      source_post_id: '',
      platform_user_id: '',
      ...(customValues?.[2] ?? {}),
    },
    {
      content: postContent4,
      thumbnail_url: demoPostSrc14,
      author: {
        uuid: kols[3].uuid,
        name: kols[3].name,
        is_verified: false,
        is_radar_star: false,
      },
      value: values[3],
      platform: 'instagram',
      is_custom_platform: false,
      origin_url: '',
      source_post_id: '',
      platform_user_id: '',
      ...(customValues?.[3] ?? {}),
    },
    {
      content: postContent5,
      thumbnail_url: demoPostSrc15,
      author: {
        uuid: kols[4].uuid,
        name: kols[4].name,
        is_verified: false,
        is_radar_star: false,
      },
      value: values[4],
      platform: 'instagram',
      is_custom_platform: false,
      origin_url: '',
      source_post_id: '',
      platform_user_id: '',
      ...(customValues?.[4] ?? {}),
    },
  ]
}

const makeDemoInsightReportKolAnalysisResponse = (
  locale: SupportedLanguages,
): InsightReportKolAnalysisResponse => {
  const kols = makeDemoInsightReportKols(locale)
  const rankingKeys = Object.keys(kolRankingSchema.shape) as KolRankingKey[]
  const summary = getKolAnalysisAiSummary(locale)
  const ai_summary = rankingKeys.map((metrics) => ({ metrics, summary }))
  const kolsCountRaning = getKolAnalysisKolRanking(locale, false)
  const kolsRateRaning = getKolAnalysisKolRanking(locale, true)
  const postsCountRanking = getKolAnalysisPostsRanking(locale, false)
  const postsRateRanking = getKolAnalysisPostsRanking(locale, true)

  return {
    data: {
      average: {
        like_count: 174.6,
        comment_count: 7,
        engagement_count: 182,
        view_count: 42.4,
        reach_count: 16.5,
        click_count: 1.5,
        engagement_rate: 0.007734675143643967,
        view_rate: 0.0018019243191785945,
        reach_rate: 0.0003793452271473239,
        click_rate: 0.00003448592974066581,
      },
      post_ranking: {
        by_like_count: postsCountRanking,
        by_comment_count: postsCountRanking,
        by_engagement_count: postsCountRanking,
        by_engagement_rate: postsRateRanking,
        by_view_count: getKolAnalysisPostsRanking(locale, true, [
          {
            value: 100,
            thumbnail_url: demoPostSrc9,
            author: {
              uuid: kols[0].uuid,
              name: kols[0].name,
              is_verified: false,
              is_radar_star: false,
            },
            content: makePostContent6(locale),
          },
          {
            value: 40,
            thumbnail_url: demoPostSrc13,
            author: {
              uuid: kols[2].uuid,
              name: kols[2].name,
              is_verified: false,
              is_radar_star: false,
            },
            content: makePostContent3(locale),
          },
          {
            value: 40,
            thumbnail_url: demoPostSrc11,
            author: {
              uuid: kols[0].uuid,
              name: kols[0].name,
              is_verified: false,
              is_radar_star: false,
            },
            content: makePostContent1(locale),
          },
          {
            value: 30,
            thumbnail_url: demoPostSrc14,
            author: {
              uuid: kols[3].uuid,
              name: kols[3].name,
              is_verified: false,
              is_radar_star: false,
            },
            content: makePostContent4(locale),
          },
          {
            value: 2,
            thumbnail_url: demoPostSrc15,
            author: {
              uuid: kols[4].uuid,
              name: kols[4].name,
              is_verified: false,
              is_radar_star: false,
            },
            content: makePostContent5(locale),
          },
        ]),
        by_view_rate: postsRateRanking,
        by_reach_count: postsCountRanking,
        by_reach_rate: postsRateRanking,
        by_click_count: postsCountRanking,
        by_click_rate: postsRateRanking,
      },
      kol_ranking: {
        by_like_count: kolsCountRaning,
        by_comment_count: kolsCountRaning,
        by_engagement_count: kolsCountRaning,
        by_engagement_rate: kolsRateRaning,
        by_view_count: kolsCountRaning,
        by_view_rate: kolsRateRaning,
        by_reach_count: kolsCountRaning,
        by_reach_rate: kolsRateRaning,
        by_click_count: kolsCountRaning,
        by_click_rate: kolsRateRaning,
      },
      customized_tag_ranking: {
        by_like_count: [
          {
            name: 'Education',
            value: 267,
            sub_tags: [
              {
                name: 'Education',
                value: 267,
              },
            ],
          },
          {
            name: 'Food',
            value: 1746,
            sub_tags: [
              {
                name: 'Food/Beverage',
                value: 853,
              },
              {
                name: 'Food/Dessert',
                value: 20,
              },
              {
                name: 'Food',
                value: 873,
              },
            ],
          },
          {
            name: 'Daily Topics',
            value: 586,
            sub_tags: [
              {
                name: 'Daily Topics/Holidays',
                value: 586,
              },
            ],
          },
          {
            name: 'Medical and Health',
            value: 20,
            sub_tags: [
              {
                name: 'Medical and Health/Nutrition & Health Care',
                value: 20,
              },
            ],
          },
        ],
        by_comment_count: [
          {
            name: 'Education',
            value: 8,
            sub_tags: [
              {
                name: 'Education',
                value: 8,
              },
            ],
          },
          {
            name: 'Food',
            value: 56,
            sub_tags: [
              {
                name: 'Food/Beverage',
                value: 21,
              },
              {
                name: 'Food/Dessert',
                value: 0,
              },
              {
                name: 'Food',
                value: 35,
              },
            ],
          },
          {
            name: 'Daily Topics',
            value: 13,
            sub_tags: [
              {
                name: 'Daily Topics/Holidays',
                value: 13,
              },
            ],
          },
          {
            name: 'Medical and Health',
            value: 0,
            sub_tags: [
              {
                name: 'Medical and Health/Nutrition & Health Care',
                value: 0,
              },
            ],
          },
        ],
        by_engagement_count: [
          {
            name: 'Education',
            sub_tags: [
              {
                name: 'Education',
                value: 275,
              },
            ],
          },
          {
            name: 'Food',
            sub_tags: [
              {
                name: 'Food/Beverage',
                value: 876,
              },
              {
                name: 'Food/Dessert',
                value: 20,
              },
              {
                name: 'Food',
                value: 910,
              },
            ],
          },
          {
            name: 'Daily Topics',
            sub_tags: [
              {
                name: 'Daily Topics/Holidays',
                value: 601,
              },
            ],
          },
          {
            name: 'Medical and Health',
            sub_tags: [
              {
                name: 'Medical and Health/Nutrition & Health Care',
                value: 20,
              },
            ],
          },
        ],
        by_view_count: [
          {
            name: 'Education',
            value: 40,
            sub_tags: [
              {
                name: 'Education',
                value: 40,
              },
            ],
          },
          {
            name: 'Food',
            value: 392,
            sub_tags: [
              {
                name: 'Food/Beverage',
                value: 140,
              },
              {
                name: 'Food/Dessert',
                value: 40,
              },
              {
                name: 'Food',
                value: 212,
              },
            ],
          },
          {
            name: 'Daily Topics',
            value: 100,
            sub_tags: [
              {
                name: 'Daily Topics/Holidays',
                value: 100,
              },
            ],
          },
          {
            name: 'Medical and Health',
            value: 40,
            sub_tags: [
              {
                name: 'Medical and Health/Nutrition & Health Care',
                value: 40,
              },
            ],
          },
        ],
        by_reach_count: [
          {
            name: 'Education',
            sub_tags: [
              {
                name: 'Education',
              },
            ],
          },
          {
            name: 'Food',
            value: 63,
            sub_tags: [
              {
                name: 'Food/Beverage',
                value: 30,
              },
              {
                name: 'Food/Dessert',
              },
              {
                name: 'Food',
                value: 33,
              },
            ],
          },
          {
            name: 'Daily Topics',
            value: 30,
            sub_tags: [
              {
                name: 'Daily Topics/Holidays',
                value: 30,
              },
            ],
          },
          {
            name: 'Medical and Health',
            sub_tags: [
              {
                name: 'Medical and Health/Nutrition & Health Care',
              },
            ],
          },
        ],
        by_click_count: [
          {
            name: 'Education',
            sub_tags: [
              {
                name: 'Education',
              },
            ],
          },
          {
            name: 'Food',
            value: 5,
            sub_tags: [
              {
                name: 'Food/Beverage',
                value: 2,
              },
              {
                name: 'Food/Dessert',
              },
              {
                name: 'Food',
                value: 3,
              },
            ],
          },
          {
            name: 'Daily Topics',
            value: 2,
            sub_tags: [
              {
                name: 'Daily Topics/Holidays',
                value: 2,
              },
            ],
          },
          {
            name: 'Medical and Health',
            sub_tags: [
              {
                name: 'Medical and Health/Nutrition & Health Care',
              },
            ],
          },
        ],
        by_engagement_rate: [
          {
            name: 'Education',
            value: 0.013268998793727383,
            sub_tags: [
              {
                name: 'Education',
                value: 0.013268998793727383,
              },
            ],
          },
          {
            name: 'Food',
            value: 0.007879649909685076,
            sub_tags: [
              {
                name: 'Food/Beverage',
                value: 0.008369639990827791,
              },
              {
                name: 'Food/Dessert',
                value: 0.002906131938390003,
              },
              {
                name: 'Food',
                value: 0.007734675143643967,
              },
            ],
          },
          {
            name: 'Daily Topics',
            value: 0.007159961400540869,
            sub_tags: [
              {
                name: 'Daily Topics/Holidays',
                value: 0.007159961400540869,
              },
            ],
          },
          {
            name: 'Medical and Health',
            value: 0.002906131938390003,
            sub_tags: [
              {
                name: 'Medical and Health/Nutrition & Health Care',
                value: 0.002906131938390003,
              },
            ],
          },
        ],
        by_view_rate: [
          {
            name: 'Education',
            value: 0.0019300361881785283,
            sub_tags: [
              {
                name: 'Education',
                value: 0.0019300361881785283,
              },
            ],
          },
          {
            name: 'Food',
            value: 0.0017103116083037374,
            sub_tags: [
              {
                name: 'Food/Beverage',
                value: 0.001337613697164259,
              },
              {
                name: 'Food/Dessert',
                value: 0.005812263876780006,
              },
              {
                name: 'Food',
                value: 0.0018019243191785945,
              },
            ],
          },
          {
            name: 'Daily Topics',
            value: 0.0011913413312048034,
            sub_tags: [
              {
                name: 'Daily Topics/Holidays',
                value: 0.0011913413312048034,
              },
            ],
          },
          {
            name: 'Medical and Health',
            value: 0.005812263876780006,
            sub_tags: [
              {
                name: 'Medical and Health/Nutrition & Health Care',
                value: 0.005812263876780006,
              },
            ],
          },
        ],
        by_reach_rate: [
          {
            name: 'Education',
            sub_tags: [
              {
                name: 'Education',
              },
            ],
          },
          {
            name: 'Food',
            value: 0.00036856977376836266,
            sub_tags: [
              {
                name: 'Food/Beverage',
                value: 0.00035740239936144104,
              },
              {
                name: 'Food/Dessert',
              },
              {
                name: 'Food',
                value: 0.0003793452271473239,
              },
            ],
          },
          {
            name: 'Daily Topics',
            value: 0.00035740239936144104,
            sub_tags: [
              {
                name: 'Daily Topics/Holidays',
                value: 0.00035740239936144104,
              },
            ],
          },
          {
            name: 'Medical and Health',
            sub_tags: [
              {
                name: 'Medical and Health/Nutrition & Health Care',
              },
            ],
          },
        ],
        by_click_rate: [
          {
            name: 'Education',
            sub_tags: [
              {
                name: 'Education',
              },
            ],
          },
          {
            name: 'Food',
            value: 0.00002925156934669545,
            sub_tags: [
              {
                name: 'Food/Beverage',
                value: 0.00002382682662409607,
              },
              {
                name: 'Food/Dessert',
              },
              {
                name: 'Food',
                value: 0.00003448592974066581,
              },
            ],
          },
          {
            name: 'Daily Topics',
            value: 0.00002382682662409607,
            sub_tags: [
              {
                name: 'Daily Topics/Holidays',
                value: 0.00002382682662409607,
              },
            ],
          },
          {
            name: 'Medical and Health',
            sub_tags: [
              {
                name: 'Medical and Health/Nutrition & Health Care',
              },
            ],
          },
        ],
      },
      follower_level_ranking: {
        by_like_count: [
          {
            level: 'small',
          },
          {
            level: 'mid-small',
            value: 586,
          },
          {
            level: 'medium',
          },
          {
            level: 'mid-large',
          },
          {
            level: 'large',
          },
          {
            level: 'million',
          },
          {
            level: 'nano',
            value: 20,
          },
          {
            level: 'micro',
            value: 267,
          },
        ],
        by_comment_count: [
          {
            level: 'small',
          },
          {
            level: 'mid-small',
            value: 13,
          },
          {
            level: 'medium',
          },
          {
            level: 'mid-large',
          },
          {
            level: 'large',
          },
          {
            level: 'million',
          },
          {
            level: 'nano',
            value: 14,
          },
          {
            level: 'micro',
            value: 8,
          },
        ],
        by_engagement_count: [
          {
            level: 'small',
          },
          {
            level: 'mid-small',
            value: 601,
          },
          {
            level: 'medium',
          },
          {
            level: 'mid-large',
          },
          {
            level: 'large',
          },
          {
            level: 'million',
          },
          {
            level: 'nano',
            value: 34,
          },
          {
            level: 'micro',
            value: 275,
          },
        ],
        by_view_count: [
          {
            level: 'small',
          },
          {
            level: 'mid-small',
            value: 100,
          },
          {
            level: 'medium',
          },
          {
            level: 'mid-large',
          },
          {
            level: 'large',
          },
          {
            level: 'million',
          },
          {
            level: 'nano',
            value: 72,
          },
          {
            level: 'micro',
            value: 40,
          },
        ],
        by_reach_count: [
          {
            level: 'small',
          },
          {
            level: 'mid-small',
            value: 30,
          },
          {
            level: 'medium',
          },
          {
            level: 'mid-large',
          },
          {
            level: 'large',
          },
          {
            level: 'million',
          },
          {
            level: 'nano',
            value: 3,
          },
          {
            level: 'micro',
          },
        ],
        by_click_count: [
          {
            level: 'small',
          },
          {
            level: 'mid-small',
            value: 2,
          },
          {
            level: 'medium',
          },
          {
            level: 'mid-large',
          },
          {
            level: 'large',
          },
          {
            level: 'million',
          },
          {
            level: 'nano',
            value: 1,
          },
          {
            level: 'micro',
          },
        ],
        by_engagement_rate: [
          {
            level: 'small',
          },
          {
            level: 'mid-small',
            value: 0.007159961400540869,
          },
          {
            level: 'medium',
          },
          {
            level: 'mid-large',
          },
          {
            level: 'large',
          },
          {
            level: 'million',
          },
          {
            level: 'nano',
            value: 0.002617801047120419,
          },
          {
            level: 'micro',
            value: 0.013268998793727383,
          },
        ],
        by_view_rate: [
          {
            level: 'small',
          },
          {
            level: 'mid-small',
            value: 0.0011913413312048034,
          },
          {
            level: 'medium',
          },
          {
            level: 'mid-large',
          },
          {
            level: 'large',
          },
          {
            level: 'million',
          },
          {
            level: 'nano',
            value: 0.00554357868801971,
          },
          {
            level: 'micro',
            value: 0.0019300361881785283,
          },
        ],
        by_reach_rate: [
          {
            level: 'small',
          },
          {
            level: 'mid-small',
            value: 0.00035740239936144104,
          },
          {
            level: 'medium',
          },
          {
            level: 'mid-large',
          },
          {
            level: 'large',
          },
          {
            level: 'million',
          },
          {
            level: 'nano',
            value: 0.000982640026203734,
          },
          {
            level: 'micro',
          },
        ],
        by_click_rate: [
          {
            level: 'small',
          },
          {
            level: 'mid-small',
            value: 0.00002382682662409607,
          },
          {
            level: 'medium',
          },
          {
            level: 'mid-large',
          },
          {
            level: 'large',
          },
          {
            level: 'million',
          },
          {
            level: 'nano',
            value: 0.00032754667540124465,
          },
          {
            level: 'micro',
          },
        ],
      },
      ai_summary,
    },
  }
}

const getWords = (locale: SupportedLanguages): string[] => {
  switch (locale) {
    case 'zh':
      return [
        '好吃',
        '超美',
        '夢幻',
        '可愛',
        '滿分',
        '超療癒',
        '再來一份',
        '喜歡',
        '美味',
        '溫暖',
        '滿足',
        '優雅',
        '太誘人',
        '美到不行',
        '看了就餓',
        '草莓',
        '抹茶',
        '生乳捲',
        '蛋糕',
        '巧克力',
        '奶油',
        '糖霜',
        '手作',
        '甜點控',
        '下午茶',
        '想吃',
        '哪裡買',
        '口感',
        '顏值高',
        '馬上收藏',
      ]
    case 'ja':
      return [
        'おいしい',
        '超きれい',
        '夢のよう',
        'かわいい',
        '満点',
        '癒し',
        'もう一つ',
        '好き',
        '美味',
        'あたたかい',
        '満足',
        '上品',
        '誘惑的',
        '美しすぎる',
        '見たらお腹すく',
        'いちご',
        '抹茶',
        'ロールケーキ',
        'ケーキ',
        'チョコ',
        'クリーム',
        'アイシング',
        '手作り',
        'スイーツ好き',
        'アフタヌーンティー',
        '食べたい',
        'どこで買える？',
        '食感',
        '映え',
        '保存必須',
      ]
    default:
      return [
        'Delicious',
        'So beautiful',
        'Dreamy',
        'Cute',
        'Full marks',
        'Healing',
        'One more',
        'Love it',
        'Tasty',
        'Warm',
        'Satisfying',
        'Elegant',
        'Too tempting',
        'Stunning',
        'Hungry now',
        'Strawberry',
        'Matcha',
        'Roll cake',
        'Cake',
        'Chocolate',
        'Cream',
        'Frosting',
        'Handmade',
        'Dessert lover',
        'Afternoon tea',
        'Want to eat',
        'Where to buy',
        'Texture',
        'Pretty',
        'Saving it',
      ]
  }
}

const getCommentAiSummary = (locale: SupportedLanguages): string => {
  switch (locale) {
    case 'zh':
      return '留言中最常被提及的關鍵詞為「好吃」與「超美」，顯示受眾對於甜點的口感與外觀皆有高度肯定。不僅味道獲得認可，視覺呈現亦成功吸引眼球，整體留言情感偏向正向，顯示甜點貼文在視覺與食慾上皆引發共鳴。'
    case 'ja':
      return '「おいしい」「超きれい」が最も多く言及されており、味と見た目の両方で高評価を得ています。全体的にポジティブな感情が多く、視覚・味覚ともに共感を呼ぶ内容となっています。'
    default:
      return 'Keywords like "delicious" and "so beautiful" appeared most frequently in the comments, indicating high appreciation for both taste and presentation. Overall sentiment was overwhelmingly positive, showing the visual and sensory appeal of dessert posts.'
  }
}

const makeDemoInsightReportCommentAnalysisResponse = (
  locale: SupportedLanguages,
): InsightReportCommentAnalysisResponse => {
  const kols = makeDemoInsightReportKols(locale)
  const wordTexts = getWords(locale)
  const wordCounts = [
    1, 10, 10, 1, 25, 135, 3, 1, 3, 6, 2, 23, 5, 1, 2, 1, 2, 1, 19, 1, 3, 1, 1,
    3, 1, 3, 1, 3, 64, 1,
  ]
  const words = wordTexts.map((text, index) => ({
    word: text,
    count: wordCounts[index],
    is_included: true,
  }))

  return {
    data: {
      kol_sentiments: [
        {
          ...kols[0],
          positive: 80,
          negative: 0,
          neutral: 20,
          unknown: 0,
        },
        {
          ...kols[1],
          positive: 100,
          negative: 0,
          neutral: 0,
          unknown: 0,
        },
        {
          ...kols[2],
          positive: 100,
          negative: 0,
          neutral: 0,
          unknown: 0,
        },
        {
          ...kols[3],
          positive: 50,
          negative: 50,
          neutral: 0,
          unknown: 0,
        },
      ],
      word_cloud: {
        ai_summary: getCommentAiSummary(locale),
        words,
      },
    },
  }
}

const getCommentContents = (locale: SupportedLanguages): string[] => {
  switch (locale) {
    case SupportedLanguages.zhTW:
      return [
        '會不會胖',
        '我猜這一個超過250塊',
        '😍❤️😍❤️😍❤️',
        '好美❤️💋',
        '❤️',
        '❤️❤️',
        '還行👍',
        '😍😍😍😍😍',
        '😍😍😍😍',
        '這個很好吃！必吃名單！🤤🤤🤤',
        '顏值高，看起來超讚！🍓🫙',
        '好可愛',
        '滿分表現！😍',
        '超療癒的甜點❤️',
        '優雅的擺盤💫',
      ]
    case SupportedLanguages.ja:
      return [
        '太らないかな',
        'これ250円以上すると思う',
        '😍❤️😍❤️😍❤️',
        'きれい❤️💋',
        '❤️',
        '❤️❤️',
        'まあまあ👍',
        '😍😍😍😍😍',
        '😍😍😍😍',
        'これは美味しい！絶対食べるべき！🤤🤤🤤',
        '映えますね、最高！🍓🫙',
        'かわいい',
        '満点です！😍',
        'すごく癒される❤️',
        '上品なスイーツ💫',
      ]
    default:
      return [
        'Will this make me fat?',
        'I bet this one is over $250',
        '😍❤️😍❤️😍❤️',
        'So beautiful❤️💋',
        '❤️',
        '❤️❤️',
        'Not bad👍',
        '😍😍😍😍😍',
        '😍😍😍😍',
        'This is delicious! Must-try!🤤🤤🤤',
        'That looks pretty amazing!🍓🫙',
        'So cute',
        'Full marks!😍',
        'So healing❤️',
        'Elegant dessert💫',
      ]
  }
}

const makeDemoInsightReportCommentsResponse = (
  locale: SupportedLanguages,
): InsightReportCommentsResponse => {
  const kols = makeDemoInsightReportKols(locale)
  const commentContents = getCommentContents(locale)
  const authos = [
    'panda_8726',
    'tiger_chen',
    'bella_4321',
    'piano_michelle',
    'kevin7890123',
    'maxpower629',
    'amy990312',
    'william.lin',
    'sam20050809',
    'xsophiax',
    'alex_k',
    'melody_star',
  ]
  const comments = commentContents.map((content, index) => ({
    id: index + 1,
    published_at: '2025-03-03T08:32:20Z',
    origin_url: '',
    author_name: authos[index],
    content,
    kol: kols[0],
  }))

  return {
    data: comments,
    page: 1,
    per_page: 12,
    total: 36,
  }
}

const getInfinitePostContents = (locale: SupportedLanguages): string[] => {
  switch (locale) {
    case SupportedLanguages.zhTW:
      return [
        '關於油酥塔皮（Pâte Brisée）之成分組成與製程分析，\n採用砂狀拌合法進行混合，\n麵糰須冷藏鬆弛至少12小時🥐',
        '雖然平常沒什麼聲音，也是有努力在生活。\n\n四月份課程表｜\n《主廚經典派實作課》\n《基礎甜點示範課》',
        '˙Ⱉ˙\n綠葡萄優格玄米塔\n-\n綠葡萄跟優格果然是天生一對\n真的不管做幾次都還是好喜歡(⸝⸝ᵒ̴̶̷ ·̫ ᵒ̴̶̷⸝⸝) ♡',
        '芋圓王旗艦店就在溫泉公園的旁邊，\n先到公園走走、泡泡腳，\n再來吃甜點，休閒放鬆的好行程❤️',
        '#徵才資訊\n正在尋找有經驗的甜點師加入團隊❤️‍🔥\n需要靈活應對與持續學習的精神，\n團隊氛圍融洽輕鬆，但面對產品認真嚴謹',
        '˙Ⱉ˙\n蜂蜜金桔柑橘茶香塔\n-\n家裡種了一顆金桔樹，今年不知道怎麼了突然瘋狂生長，\n就趁著還新鮮的時候摘下來做成甜點🍊',
        '#工商時間\n\n｜春季限定帕妃杯｜預訂連接🔗\n以開心果與草莓為主角，\n融合日法甜點技術，層層堆疊',
        '草莓蛋糕無敵療癒🍰\n#甜點日常 \n#尋找美味 \n#瓶子甜點 \n#草莓控 \n#甜點狂熱 \n#餓餓',
        '將檸檬奶餡修改成以金桔為主體的金桔奶餡，\n拌入一些蜂蜜，吃起來溫順許多，\n香氣也比較豐富(///▽///)',
        '應徵職務：甜點師\n薪資範圍：前2個月訓練期薪水30000，\n2個月後依工作能力調整至32000-38000\n需熟知基本甜點製作',
        '風味層次介紹：\n* 清新果香：日式味醂漬杏桃\n* 奶香與堅果風味：開心果輕奶酪\n* 酸甜點綴：覆盆子果醬🍓',
        '製作西式甜點（個人小蛋糕、塔、泡芙…等）\n需對原物料/備品/包材各品項做安全庫存量盤點及控管📋',
        '這次將常見的基礎配方進行改良，\n底部塗上了薄薄一層的柑橘果醬，\n特別有驚喜感✨',
        '是說，最近正好在整理以前的舊照片，\n看到了多年前剛學做甜點的紀錄照，\n果然什麼事情做久了都能熟能生巧呢🥹',
        '這款春日氣息的甜點，像是走進一座綻放的花園，\n每一口都帶來豐富、美麗的層次體驗🌸',
      ]
    case SupportedLanguages.ja:
      return [
        'パート・ブリゼの成分組成と製法分析について、\nサブラージュ法で混合し、\n生地は最低12時間冷蔵で休ませる必要あり🥐',
        '普段はあまり声を出さないけど、\n一生懸命生活してる。\n\n4月のレッスン｜\n《シェフ特製パイ実習》\n《基礎スイーツ講座》',
        '˙Ⱉ˙\n緑ブドウヨーグルト玄米タルト\n-\n緑ブドウとヨーグルトは本当に相性抜群\n何度作っても大好き(⸝⸝ᵒ̴̶̷ ·̫ ᵒ̴̶̷⸝⸝) ♡',
        'いもだんご王フラッグシップ店は温泉公園のすぐ隣、\n先に公園を散策、足湯で一休み、\nそれからスイーツを楽しむ最高のコース❤️',
        '#スタッフ募集\n経験豊富なパティシエを募集中❤️‍🔥\n柔軟な対応力と学び続ける姿勢が必要です、\nチームは和やかですが、商品には真摯に向き合います',
        '˙Ⱉ˙\nハチミツ金柑シトラス茶香タルト\n-\n家の金柑の木が、今年はなぜか急成長して、\n新鮮なうちに収穫してスイーツにしました🍊',
        '#PR\n\n｜春の限定パフェカップ｜予約受付中🔗\nピスタチオとストロベリーがメイン、\n日仏の技術を融合し、層を重ねた逸品',
        'ストロベリーケーキ超癒し系🍰\n#スイーツ日記 \n#グルメ探訪 \n#瓶詰めスイーツ \n#いちご好き \n#スイーツ中毒 \n#お腹すいた',
        'レモンクリームを金柑ベースにアレンジ、\nはちみつを加えて優しい味わいに、\n香りも豊かになりました(///▽///)',
        '募集職種：パティシエ\n給与：研修期間2ヶ月30000、\nその後、能力に応じて32000-38000に調整\n基本的な製菓技術は必須',
        'フレーバー層のご紹介：\n* フレッシュな果実味：みりん漬けあんず\n* ミルキーナッツ：ピスタチオレアチーズ\n* 甘酸っぱいアクセント：ラズベリージャム🍓',
        '洋菓子の製造（個人用ケーキ、タルト、シュー等）\n原材料・備品・包材の在庫管理と発注業務📋',
        '今回は定番レシピをアレンジ、\n底に柑橘ジャムを薄く塗って、\n食べた時のサプライズ感を演出✨',
        'そういえば、最近昔の写真を整理してて、\n製菓を始めた頃の記録を見返したら、\n継続は力なりって本当だなって実感🥹',
        'この春の息吹を感じるスイーツは、花咲く庭園に迷い込んだよう、\n一口ごとに豊かで美しい層が広がります🌸',
      ]
    default:
      return [
        'Analysis on Pâte Brisée composition and process,\nusing sablage method for mixing,\ndough must rest in fridge for at least 12 hours🥐',
        "Though usually quiet, still working hard at life.\n\nApril Class Schedule｜\n《Chef's Classic Tart Workshop》\n《Basic Pastry Demo Class》",
        '˙Ⱉ˙\nGreen Grape Yogurt Genmaicha Tart\n-\nGreen grapes and yogurt are truly a perfect match\nLove it every time I make it(⸝⸝ᵒ̴̶̷ ·̫ ᵒ̴̶̷⸝⸝) ♡',
        'Taro Ball King Flagship Store right next to the hot spring park,\nFirst take a walk in the park, soak your feet,\nthen enjoy desserts - perfect relaxing itinerary❤️',
        '#HiringNow\nLooking for experienced pastry chef to join❤️‍🔥\nNeed flexibility and continuous learning spirit,\nTeam atmosphere is relaxed but serious about products',
        '˙Ⱉ˙\nHoney Kumquat Citrus Tea Tart\n-\nMy kumquat tree at home grew like crazy this year,\nSo I picked them while fresh and made dessert🍊',
        '#Sponsored\n\n｜Spring Limited Parfait Cup｜Pre-order now🔗\nFeaturing pistachio and strawberry,\nJapanese-French techniques layered together',
        'Strawberry cake super healing🍰\n#DessertLife \n#FoodHunting \n#BottledDesserts \n#StrawberryLover \n#DessertAddict \n#Hungry',
        'Modified lemon filling to be kumquat-based,\nadded some honey for a gentler taste,\nrich aroma too(///▽///)',
        'Position: Pastry Chef\nSalary: Training period 2 months 30000,\nThen adjusted to 32000-38000 based on ability\nBasic pastry skills required',
        'Flavor layers intro:\n* Fresh fruit notes: Mirin-marinated apricot\n* Milky & nutty: Pistachio light cheesecake\n* Sweet-sour accent: Raspberry jam🍓',
        'Making Western desserts (cakes, tarts, choux, etc.)\nInventory management of ingredients/supplies/packaging📋',
        'This time I improved the classic recipe,\nAdded a thin layer of citrus jam at the bottom,\nCreates a pleasant surprise when eating✨',
        'By the way, I was recently sorting old photos,\nFound records from when I first started making desserts,\nPractice really does make perfect🥹',
        'This spring-inspired dessert feels like walking into a blooming garden,\nEach bite brings rich, beautiful layers of experience🌸',
      ]
  }
}

const makeDemoInsightReportInfinitePostsResponse = (
  locale: SupportedLanguages,
): InsightReportInfinitePostsResponse => {
  const kols = makeDemoInsightReportKols(locale)
  const contents = getInfinitePostContents(locale)

  return {
    data: [
      {
        id: 27966,
        source_post_id: '',
        published_at: '2025-03-31T14:20:02Z',
        platform: 'facebook',
        is_custom_platform: false,
        post_type: 'post',
        is_custom_post_type: false,
        origin_url: '',
        thumbnail_url: demoPostSrc10,
        content: contents[0],
        like_count: 161,
        comment_count: 3,
        share_count: 8,
        kol: kols[0],
        platform_user_id: '',
        is_handfilled: false,
        is_collection_post: false,
      },
      {
        id: 27969,
        source_post_id: '',
        published_at: '2025-03-30T07:29:41Z',
        platform: 'facebook',
        is_custom_platform: false,
        post_type: 'post',
        is_custom_post_type: false,
        origin_url: '',
        thumbnail_url: demoPostSrc11,
        content: contents[1],
        like_count: 149,
        comment_count: 0,
        share_count: 0,
        is_handfilled: false,
        kol: kols[1],
        platform_user_id: '',
        is_collection_post: false,
      },
      {
        id: 27967,
        source_post_id: '',
        published_at: '2025-03-25T09:59:40Z',
        platform: 'instagram',
        is_custom_platform: false,
        post_type: 'post',
        is_custom_post_type: false,
        origin_url: '',
        thumbnail_url: demoPostSrc12,
        content: contents[2],
        like_count: 0,
        comment_count: 2,
        view_count: 30,
        click_count: 1,
        is_handfilled: false,
        kol: kols[2],
        platform_user_id: '',
        is_collection_post: false,
      },
      {
        id: 27968,
        source_post_id: '',
        published_at: '2025-03-14T05:18:11Z',
        platform: 'youtube',
        is_custom_platform: false,
        post_type: 'shorts',
        is_custom_post_type: false,
        origin_url: '',
        thumbnail_url: demoPostSrc13,
        content: contents[3],
        like_count: 6,
        comment_count: 0,
        share_count: 0,
        view_count: 445,
        is_handfilled: false,
        kol: kols[4],
        platform_user_id: '',
        is_collection_post: false,
      },
      {
        id: 27964,
        source_post_id: '',
        published_at: '2025-03-12T16:03:03Z',
        platform: 'facebook',
        is_custom_platform: false,
        post_type: 'post',
        is_custom_post_type: false,
        origin_url: '',
        thumbnail_url: demoPostSrc14,
        content: contents[4],
        like_count: 11,
        comment_count: 0,
        share_count: 0,
        view_count: 3,
        is_handfilled: false,
        kol: kols[3],
        platform_user_id: '',
        is_collection_post: false,
      },
      {
        id: 27973,
        source_post_id: '',
        published_at: '2025-03-12T16:02:58Z',
        platform: 'instagram',
        is_custom_platform: false,
        post_type: 'post',
        is_custom_post_type: false,
        origin_url: '',
        thumbnail_url: demoPostSrc15,
        content: contents[5],
        like_count: 267,
        comment_count: 8,
        view_count: 40,
        is_handfilled: false,
        kol: kols[3],
        platform_user_id: '',
        is_collection_post: false,
      },
      {
        id: 27972,
        source_post_id: '',
        published_at: '2025-03-09T14:49:20Z',
        platform: 'instagram',
        is_custom_platform: false,
        post_type: 'post',
        is_custom_post_type: false,
        origin_url: '',
        thumbnail_url: demoPostSrc16,
        content: contents[6],
        like_count: 0,
        comment_count: 12,
        view_count: 2,
        is_handfilled: false,
        kol: kols[2],
        platform_user_id: '',
        is_collection_post: false,
      },
      {
        id: 27971,
        source_post_id: '',
        published_at: '2025-03-06T06:39:08Z',
        platform: 'instagram',
        is_custom_platform: false,
        post_type: 'post',
        is_custom_post_type: false,
        origin_url: '',
        thumbnail_url: demoPostSrc17,
        content: contents[7],
        like_count: 20,
        comment_count: 0,
        view_count: 40,
        is_handfilled: false,
        kol: kols[1],
        platform_user_id: '',
        is_collection_post: false,
      },
      {
        id: 27965,
        source_post_id: '',
        published_at: '2025-03-06T06:39:02Z',
        platform: 'facebook',
        is_custom_platform: false,
        post_type: 'post',
        is_custom_post_type: false,
        origin_url: '',
        thumbnail_url: demoPostSrc18,
        content: contents[8],
        like_count: 54,
        comment_count: 0,
        share_count: 1,
        click_count: 1,
        is_handfilled: false,
        kol: kols[1],
        platform_user_id: '',
        is_collection_post: false,
      },
      {
        id: 27970,
        source_post_id: '',
        published_at: '2025-03-03T07:57:25Z',
        platform: 'instagram',
        is_custom_platform: false,
        post_type: 'post',
        is_custom_post_type: false,
        origin_url: '',
        thumbnail_url: demoPostSrc9,
        content: contents[9],
        like_count: 586,
        comment_count: 13,
        share_count: 2,
        view_count: 100,
        click_count: 2,
        is_handfilled: false,
        kol: kols[4],
        platform_user_id: '',
        is_collection_post: false,
      },
    ],
    page: 1,
    per_page: 10,
    total: 10,
  }
}
const makeDemoInsightReportKolsResponse = (
  language: SupportedLanguages,
): InsightReportKolsResponse => {
  const kols = makeDemoInsightReportKols(language)
  const contents = getInfinitePostContents(language)
  return {
    kols: [
      {
        id: 35526,
        uuid: kols[0].uuid,
        name: kols[0].name,
        is_verified: kols[0].is_verified,
        is_radar_star: kols[0].is_radar_star,
        total_follower_count: kols[0].total_follower_count,
        total_post_budget: 2000,
        posts: [
          {
            id: 27970,
            budget: 2000,
            thumbnail_url: demoPostSrc9,
            content: contents[9],
            platform: 'instagram',
            is_custom_platform: false,
            post_type: 'post',
            is_custom_post_type: false,
            is_handfilled: false,
            is_disable_like: false,
            is_hidden: false,
            use_handfilled: true,
            like_count: 586,
            comment_count: 13,
            share_count: 2,
            view_count: 100,
            reach_count: 30,
            click_count: 2,
            handfilled: {
              like_count: 586,
              comment_count: 13,
              share_count: 2,
              view_count: 100,
              reach_count: 30,
              click_count: 2,
            },
            published_at: '2025-03-03T07:57:25Z',
            origin_url: 'https://www.instagram.com/p/DGusjQJTsxm',
            source_post_id: 'DGusjQJTsxm',
            platform_user_id: '1294758917',
          },
        ],
        created_at: '2025-04-23T11:30:23.328Z',
      },
      {
        id: 35525,
        uuid: kols[1].uuid,
        name: kols[1].name,
        is_verified: kols[1].is_verified,
        is_radar_star: kols[1].is_radar_star,
        total_follower_count: kols[1].total_follower_count,
        total_post_budget: 4000,
        posts: [
          {
            id: 27967,
            budget: 2000,
            thumbnail_url: demoPostSrc10,
            content: contents[1],
            platform: 'instagram',
            is_custom_platform: false,
            post_type: 'post',
            is_custom_post_type: false,
            is_handfilled: false,
            is_disable_like: true,
            is_hidden: false,
            use_handfilled: true,
            like_count: 0,
            comment_count: 2,
            view_count: 30,
            reach_count: 3,
            click_count: 1,
            handfilled: {
              like_count: 0,
              comment_count: 2,
              view_count: 30,
              reach_count: 3,
              click_count: 1,
            },
            published_at: '2025-03-25T09:59:40Z',
            origin_url: 'https://www.instagram.com/p/DHnkB5bzYgV',
            source_post_id: 'DHnkB5bzYgV',
            platform_user_id: '5597385993',
          },
          {
            id: 27972,
            budget: 2000,
            thumbnail_url: demoPostSrc11,
            content: contents[2],
            platform: 'instagram',
            is_custom_platform: false,
            post_type: 'post',
            is_custom_post_type: false,
            is_handfilled: false,
            is_disable_like: true,
            is_hidden: false,
            use_handfilled: true,
            like_count: 0,
            comment_count: 12,
            view_count: 2,
            handfilled: {
              like_count: 0,
              comment_count: 12,
              view_count: 2,
            },
            published_at: '2025-03-09T14:49:20Z',
            origin_url: 'https://www.instagram.com/p/DG-4dgbT_GL',
            source_post_id: 'DG-4dgbT_GL',
            platform_user_id: '5597385993',
          },
        ],
        created_at: '2025-04-23T11:30:23.328Z',
      },
      {
        id: 35523,
        uuid: kols[2].uuid,
        name: kols[2].name,
        is_verified: kols[2].is_verified,
        is_radar_star: kols[2].is_radar_star,
        total_follower_count: kols[2].total_follower_count,
        total_post_budget: 10000,
        posts: [
          {
            id: 27968,
            budget: 10000,
            thumbnail_url: demoPostSrc12,
            content: contents[3],
            platform: 'youtube',
            is_custom_platform: false,
            post_type: 'shorts',
            is_custom_post_type: false,
            is_handfilled: false,
            is_disable_like: false,
            is_hidden: false,
            use_handfilled: false,
            like_count: 6,
            comment_count: 0,
            share_count: 0,
            view_count: 445,
            handfilled: {},
            published_at: '2025-03-14T05:18:11Z',
            origin_url: 'https://www.youtube.com/watch?v=Kq3qFBqJvpQ',
            source_post_id: 'Kq3qFBqJvpQ',
            platform_user_id: 'UCn7rXtCLrQr2mCk-zaoYfuQ',
          },
        ],
        created_at: '2025-04-23T11:30:23.328Z',
      },
      {
        id: 35524,
        uuid: kols[3].uuid,
        name: kols[3].name,
        is_verified: kols[3].is_verified,
        is_radar_star: kols[3].is_radar_star,
        total_follower_count: kols[3].total_follower_count,
        total_post_budget: 0,
        posts: [
          {
            id: 27965,
            thumbnail_url: demoPostSrc13,
            content: contents[4],
            platform: 'facebook',
            is_custom_platform: false,
            post_type: 'post',
            is_custom_post_type: false,
            is_handfilled: false,
            is_disable_like: false,
            is_hidden: false,
            use_handfilled: true,
            like_count: 54,
            comment_count: 0,
            share_count: 1,
            reach_count: 3,
            click_count: 1,
            handfilled: {
              like_count: 54,
              comment_count: 0,
              share_count: 1,
              reach_count: 3,
              click_count: 1,
            },
            published_at: '2025-03-06T06:39:02Z',
            origin_url:
              'https://www.facebook.com/637640919704323/posts/1168527164641269',
            source_post_id: '1168527164641269',
            platform_user_id: '637640919704323',
          },
          {
            id: 27966,
            thumbnail_url: demoPostSrc14,
            content: contents[5],
            platform: 'facebook',
            is_custom_platform: false,
            post_type: 'post',
            is_custom_post_type: false,
            is_handfilled: false,
            is_disable_like: false,
            is_hidden: false,
            use_handfilled: false,
            like_count: 161,
            comment_count: 3,
            share_count: 8,
            handfilled: {},
            published_at: '2025-03-31T14:20:02Z',
            origin_url:
              'https://www.facebook.com/637640919704323/posts/1187565202737465',
            source_post_id: '1187565202737465',
            platform_user_id: '637640919704323',
          },
          {
            id: 27969,
            thumbnail_url: demoPostSrc15,
            content: contents[6],
            platform: 'facebook',
            is_custom_platform: false,
            post_type: 'post',
            is_custom_post_type: false,
            is_handfilled: false,
            is_disable_like: false,
            is_hidden: false,
            use_handfilled: false,
            like_count: 149,
            comment_count: 0,
            share_count: 0,
            handfilled: {},
            published_at: '2025-03-30T07:29:41Z',
            origin_url:
              'https://www.facebook.com/637640919704323/posts/1186555166171802',
            source_post_id: '1186555166171802',
            platform_user_id: '637640919704323',
          },
          {
            id: 27971,
            thumbnail_url: demoPostSrc16,
            content: contents[7],
            platform: 'instagram',
            is_custom_platform: false,
            post_type: 'post',
            is_custom_post_type: false,
            is_handfilled: false,
            is_disable_like: false,
            is_hidden: false,
            use_handfilled: true,
            like_count: 20,
            comment_count: 0,
            view_count: 40,
            handfilled: {
              like_count: 20,
              comment_count: 0,
              view_count: 40,
            },
            published_at: '2025-03-06T06:39:08Z',
            origin_url: 'https://www.instagram.com/p/DG2R-ZFqPKP',
            source_post_id: 'DG2R-ZFqPKP',
            platform_user_id: '638286014',
          },
        ],
        created_at: '2025-04-23T11:30:23.328Z',
      },
      {
        id: 35522,
        uuid: kols[4].uuid,
        name: kols[4].name,
        is_verified: kols[4].is_verified,
        is_radar_star: kols[4].is_radar_star,
        total_follower_count: kols[4].total_follower_count,
        total_post_budget: 0,

        posts: [
          {
            id: 27964,
            thumbnail_url: demoPostSrc17,
            content: contents[8],
            platform: 'facebook',
            is_custom_platform: false,
            post_type: 'post',
            is_custom_post_type: false,
            is_handfilled: false,
            is_disable_like: false,
            is_hidden: false,
            use_handfilled: true,
            like_count: 11,
            comment_count: 0,
            share_count: 0,
            view_count: 3,
            handfilled: {
              like_count: 11,
              comment_count: 0,
              share_count: 0,
              view_count: 3,
            },
            published_at: '2025-03-12T16:03:03Z',
            origin_url:
              'https://www.facebook.com/599232066778335/posts/1039057214910992',
            source_post_id: '1039057214910992',
            platform_user_id: '599232066778335',
          },
          {
            id: 27973,
            thumbnail_url: demoPostSrc18,
            content: contents[9],
            platform: 'instagram',
            is_custom_platform: false,
            post_type: 'post',
            is_custom_post_type: false,
            is_handfilled: false,
            is_disable_like: false,
            is_hidden: false,
            use_handfilled: true,
            like_count: 267,
            comment_count: 8,
            view_count: 40,
            handfilled: {
              like_count: 267,
              comment_count: 8,
              view_count: 40,
            },
            published_at: '2025-03-12T16:02:58Z',
            origin_url: 'https://www.instagram.com/p/DHGvRYgTQ7i',
            source_post_id: 'DHGvRYgTQ7i',
            platform_user_id: '291751403',
          },
        ],
        created_at: '2025-04-23T11:30:23.328Z',
      },
    ],
    total: 10,
    page: 1,
    per_page: 10,
  }
}

const makeDemoInsightReportListResponse = (
  locale?: SupportedLanguages,
): InsightReportListResponse => {
  return {
    data: [
      {
        id: DEMO_REPORT_ID as unknown as number,
        name: getInsightReportName(locale),
        start_at: '2025-02-28T16:00:00Z',
        end_at: '2025-03-31T15:59:59.999Z',
        budget: 40000,
        kol_count: 5,
        owner: {
          id: 1,
          name: 'Demo Owner',
        },
        snapshot_at: '2025-01-01',
      },
    ],
    total: 1,
    page: 1,
    per_page: 10,
  }
}
export {
  DEMO_REPORT_ID,
  makeDemoInsightReportOverviewResponse,
  makeDemoInsightReportPerformanceResponse,
  makeDemoInsightReportCustomPostTypesResponse,
  makeDemoInsightReportKolAnalysisResponse,
  makeDemoInsightReportCommentAnalysisResponse,
  makeDemoInsightReportCommentsResponse,
  makeDemoInsightReportInfinitePostsResponse,
  makeDemoInsightReportKolsResponse,
  makeDemoInsightReportListResponse,
}
